import Pound from '@zego/pageContainers/gb/VanGb/sections/static/hiw-pound-icon.svg';
import Car from '@zego/static/images/products/motor/car.svg';
import Claims from '@zego/static/svgs/CarAccident.svg';
import Paper from '@zego/static/svgs/PaperShield.svg';
import Support from '@zego/static/svgs/Support.svg';

export const TAXI = {
  icon: Car,
  heading: 'Taxi/Private Hire insurance',
  link:
    'https://support.zego.com/s/topic/0TO4J0000002AezWAE/taxiprivate-hire-insurance',
};

export const CLAIMS = {
  icon: Claims,
  heading: 'Claims information',
  link:
    'https://support.zego.com/s/topic/0TO4J0000002AeuWAE/claims-information',
};

export const PAYMENTS = {
  icon: Pound,
  heading: 'Payments & charges',
  link: 'https://support.zego.com/s/topic/0TO4J0000002AeyWAE/payments-charges',
};

export const DOCUMENTS = {
  icon: Paper,
  heading: 'Documents',
  link: 'https://support.zego.com/s/topic/0TO4J0000002AexWAE/documents',
};

export const SUPPORT = {
  icon: Support,
  heading: 'Common questions',
  link: 'https://support.zego.com/s/topic/0TO4J0000002AevWAE/common-questions',
};
